import { CircularProgress } from '@mui/material'
import { Input, Modal } from 'Common/Supplyvue-ui'
import {
  ContentWrapper,
  ModalActionButton,
  StyledTypography,
  StyledFooter,
} from './CreateProjectModal.styles'
import { CreateProjectModalProps } from './CreateProjectModal.types'

export const CreateProjectModal = ({
  isModalOpen,
  handleModalClose,
  heading,
  projectNameLabel,
  projectName,
  handleProjectNameChange,
  actionButtonLabel,
  handleActionClick,
  isActionDisabled,
  isLoading,
  errorMessage = '',
}: CreateProjectModalProps) => {
  const handleOnKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleActionClick()
    }
  }

  const Body = (
    <ContentWrapper>
      <label>
        <StyledTypography variant="h4">{projectNameLabel}</StyledTypography>
        <Input
          error={!!errorMessage}
          helperText={errorMessage}
          fullWidth
          value={projectName}
          onChange={handleProjectNameChange}
          onKeyDown={handleOnKeyDown}
          disabled={isLoading}
          ariaLabel={projectNameLabel}
        />
      </label>
    </ContentWrapper>
  )

  const Footer = (
    <StyledFooter>
      <ModalActionButton
        onClick={handleActionClick}
        label={actionButtonLabel}
        disabled={isActionDisabled}
        variant="contained"
      >
        {isLoading && (
          <CircularProgress
            color="inherit"
            size={16}
            sx={{ marginRight: '8px' }}
          />
        )}
        {actionButtonLabel}
      </ModalActionButton>
    </StyledFooter>
  )

  return (
    <Modal
      aria-labelledby={heading}
      header={heading}
      open={isModalOpen}
      handleClose={handleModalClose}
      body={Body}
      footer={Footer}
    />
  )
}
